import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '../../core/interfaces/genomics-state.interface';
import {Observable} from 'rxjs/Observable';
import * as immutable from 'immutable';
import {IActionCreator} from '../interfaces/action-creators.interface';
import {ObjectUtils} from '../utils/Object.utils';
import {MapUtils} from "@ispm/shared/utils/Map.utils";

@Injectable()
export class StoreActionCreatorService implements IActionCreator {

    constructor(private store: Store<IgenomicsState>) { }


  getState(): Store<any> {
    return this.store;
  }

  getFromStore<T>(path: Array<string>, _store: Store<any> = this.store): Observable<T> {
    return _store.select((state: any) => ObjectUtils.walk(state,path.toString().replace(",",".")));
  }


  getObsValue<T>(objPath: Array<string>, obs: Observable<any>): Observable<T> {
    return obs
      .filter(val => this.shouldUseData(val, objPath))
      .map(storeObj => {
        if (!storeObj) {
          return storeObj;
        }
        let actualData = storeObj[objPath.shift()];
        for (const p of objPath) {
          if (actualData) {
            if (actualData instanceof immutable.Map
              || actualData instanceof immutable.Set
              || actualData instanceof immutable.Stack) {
              actualData = (<any>actualData).toJS();
            } else if (actualData instanceof Map) {
              actualData = MapUtils.convertFromMapToObject(actualData);
            }

            actualData = ObjectUtils.walk(actualData, p);
          }
        }
        return actualData;
      });
  }

  getStoreValue<T>(storePath: Array<string>, objPath: Array<string>, store: Store<any> = null): Observable<T> {

    const _store = this.getFromStore(storePath, store);

    return this.getObsValue<T>(objPath, _store);

  }


  private shouldUseData(origin: any, path: Array<string>): boolean {

    if (path.length === 0) {
      return false;
    }

    const at = path[0];

    if (typeof origin === 'undefined' || typeof origin[at] === 'undefined') {
      return false;
    } else if (Array.isArray(origin[at]) && origin[at].length === 0) {
      return false;
    } else if (immutable.Set.isSet(origin[at]) && origin[at].size === 0) {
      return false;
    } else if (immutable.Map.isMap(origin[at]) && origin[at].size === 0) {
      return false;
    } else if (!(origin && origin[at] && (typeof origin[at] === 'string' || (typeof origin[at] === 'object' && Object.keys(origin[at]).length > 0)))) {
      return false;
    }

    return true;
  }

}
